import { APIService } from '../api';
import { Model } from './Model';

export enum Roles {
    PLAYER = 1,
    ADMIN = 5,
    DEVELOPER = 6,
    SALESMAN = 7,
    FACTORY = 8,
    TRANSLATOR = 9,
    CUSTOMER = 10,
    OPS = 11,
    DESIGNER = 12,
    MEDICAL_FACTORY = 13,

    ROLE_PLAYER = 'Player',
    ROLE_ADMIN = 'Admin',
    ROLE_DEVELOPER = 'Developer',
    ROLE_SALESMAN = 'Salesman',
    ROLE_FACTORY = 'Factory',
    ROLE_TRANSLATOR = 'Translator',
    ROLE_CUSTOMER = 'Customer',
    ROLE_OPS = 'Ops',
    ROLE_DESIGNER = 'Designer',
    ROLE_MEDICAL_FACTORY = 'Medical Factory',
}

export class Role extends Model {
    public readonly blueprint = Role;
    public readonly endpoint = APIService.createEndpoint('roles');

    public name!: string;
}
